// src/components/UIComponents.js
import React, { useEffect } from 'react';

// Shared TopBar with Refresh & Back buttons
export function TopBar({ onRefresh, onBack, backText = '← Back' }) {
  const styles = {
    container: { display: 'flex', justifyContent: 'space-between', marginBottom: 10 },
    button:    { padding: '6px 12px', borderRadius: 4, cursor: 'pointer', fontSize: 14 },
    refresh:   { background: '#fff', border: '1px solid #1e90ff', color: '#1e90ff' },
    back:      { background: '#fff', border: '1px solid #ccc',    color: '#333' },
  };

  return (
    <div style={styles.container}>
      <button style={{ ...styles.button, ...styles.refresh }} onClick={onRefresh}>
        🔄 Refresh
      </button>
      <button style={{ ...styles.button, ...styles.back }} onClick={onBack}>
        {backText}
      </button>
    </div>
  );
}

// Shared Toast notification
export function Toast({ message, type = 'info', onClose }) {
  // Hooks must run unconditionally. Only start the auto-close timer when a
  // message exists. This prevents React internal warnings when message toggles.
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => onClose?.(), 3000);
    return () => clearTimeout(t);
  }, [message, onClose]);

  if (!message) return null;
  const colors = { info: '#17a2b8', success: '#28a745', error: '#dc3545' };
  const styles = {
    container: {
      position:      'fixed',
      top:           '50%',
      left:          '50%',
      transform:     'translate(-50%, -50%)',
      padding:       '12px 20px',
      background:    colors[type],
      color:         '#fff',
      borderRadius:  4,
      boxShadow:     '0 2px 6px rgba(0,0,0,0.2)',
      zIndex:        1000,
      display:       'flex',
      alignItems:    'center',
      gap:           12,
    },
    closeBtn: {
      background: 'transparent',
      border:     'none',
      color:      '#fff',
      cursor:     'pointer',
      fontSize:   16,
    },
  };
  return (
    <div style={styles.container}>
      <span>{message}</span>
      <button style={styles.closeBtn} onClick={onClose}>×</button>
    </div>
  );
}

// Shared confirmation modal (supports embedded children)
export function ConfirmModal({
  open,
  isOpen,
  title = 'Are you sure?',
  message,
  confirmText = 'Yes',
  cancelText  = 'Cancel',
  onConfirm,
  onCancel,
  children,
}) {
  if (!(open ?? isOpen)) return null;

  const styles = {
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.3)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:999 },
    box:     { background:'#fff', padding:20, borderRadius:8, boxShadow:'0 2px 10px rgba(0,0,0,0.2)', width:320, maxWidth:'90vw', textAlign:'center' },
    title:   { margin:'0 0 6px', fontSize:18 },
    msg:     { margin:'0 0 14px', color:'#333' },
    row:     { display:'flex', gap:10, justifyContent:'center', marginTop: children ? 12 : 20 },
    cancel:  { padding:'8px 16px', minWidth:100, border:'none', borderRadius:6, background:'#ccc', color:'#333', cursor:'pointer' },
    confirm: { padding:'8px 16px', minWidth:100, border:'none', borderRadius:6, background:'#dc3545', color:'#fff', cursor:'pointer' },
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.box}>
        {title   && <h3 style={styles.title}>{title}</h3>}
        {message && <p style={styles.msg}>{message}</p>}
        {children}
        <div style={styles.row}>
          <button style={styles.cancel}  onClick={onCancel}>{cancelText}</button>
          <button style={styles.confirm} onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
}
